import {
  INDIVIDUAL,
  INVALID_COUNTRY_REGEX,
  MAX_LENGTH_VALUE,
  PAY_OS_COUNTRIES
} from './constants';

export const getTaxLabel = (taxIdInformation) => {
  const label = { individualLabel: '', companyLabel: '' };
  taxIdInformation.map((item) => {
    if (item.label == INDIVIDUAL) {
      label['individualLabel'] = item.value;
    } else {
      label['companyLabel'] = item.value;
    }
  });
  return label;
};

export const getTaxIDValidation = (value, countryPayU, t) => {
  if (
    PAY_OS_COUNTRIES.includes(countryPayU) &&
    value &&
    (value.length > MAX_LENGTH_VALUE || !value.match(INVALID_COUNTRY_REGEX))
  ) {
    return t('TAX_ID_FORMAT_ERROR');
  }
};
